<template>
    <svg
      class="icon"
      :class="{ 'icon-spin': spin }"
      :height="height"
      :width="width"
    >
      <use :href="`#${icon}`" />
    </svg>
  </template>
  
  <script setup lang="ts">
  import { defineProps } from "vue";
  
  interface Props {
    icon: string;
    spin?: boolean;
    height?: string;
    width?: string;
  }
  
  defineProps<Props>();
  
  </script>
  
  <style lang="scss" scoped>
  .icon {
    fill: currentColor;
  
    &.icon-spin {
      animation: icon-spin 2s infinite linear;
    }
  }
  
  @keyframes icon-spin {
    from {
      transform: rotate(0deg);
    }
  
    to {
      transform: rotate(359deg);
    }
  }
  </style>
  